export default __webpack_public_path__ + "static/media/closeWhatsapp.8fdff600.svg";